// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.

import { mergeStyles } from '@fluentui/react';

export const errorIconStackStyle: string = mergeStyles({ fontSize: '1.25rem', fontWeight: 'bold' });

export const errorTitleStyle: string = mergeStyles({ fontSize: '1.25rem', fontWeight: 'bold' });
